/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_order_statuses_complete_delivered_removal_point = /** @type {(inputs: {}) => string} */ () => {
	return `Balíček doručen do místa vyzvednutí`
};

const da_order_statuses_complete_delivered_removal_point = /** @type {(inputs: {}) => string} */ () => {
	return `Pakke leveret til afhentningssted`
};

const de_order_statuses_complete_delivered_removal_point = /** @type {(inputs: {}) => string} */ () => {
	return `Paket an Abholstation geliefert`
};

const en_order_statuses_complete_delivered_removal_point = /** @type {(inputs: {}) => string} */ () => {
	return `Parcel delivered to a pickup point`
};

const es_order_statuses_complete_delivered_removal_point = /** @type {(inputs: {}) => string} */ () => {
	return `Paquete entregado en punto de recogida`
};

const fr_order_statuses_complete_delivered_removal_point = /** @type {(inputs: {}) => string} */ () => {
	return `Colis livré en point retrait`
};

const hu_order_statuses_complete_delivered_removal_point = /** @type {(inputs: {}) => string} */ () => {
	return `Csomag leszállítva a felvételi ponthoz`
};

const it_order_statuses_complete_delivered_removal_point = /** @type {(inputs: {}) => string} */ () => {
	return `Pacco consegnato al punto di ritiro`
};

const nl_order_statuses_complete_delivered_removal_point = /** @type {(inputs: {}) => string} */ () => {
	return `Pakket geleverd bij afhaalpunt`
};

const pl_order_statuses_complete_delivered_removal_point = /** @type {(inputs: {}) => string} */ () => {
	return `Paczka dostarczona do punktu odbioru`
};

const pt_order_statuses_complete_delivered_removal_point = /** @type {(inputs: {}) => string} */ () => {
	return `Encomenda entregue no ponto de retirada`
};

const sv_order_statuses_complete_delivered_removal_point = /** @type {(inputs: {}) => string} */ () => {
	return `Paket levererat till utlämningsställe`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const order_statuses_complete_delivered_removal_point = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.order_statuses_complete_delivered_removal_point(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("order_statuses_complete_delivered_removal_point", locale)
	if (locale === "cs") return cs_order_statuses_complete_delivered_removal_point(inputs)
	if (locale === "da") return da_order_statuses_complete_delivered_removal_point(inputs)
	if (locale === "de") return de_order_statuses_complete_delivered_removal_point(inputs)
	if (locale === "en") return en_order_statuses_complete_delivered_removal_point(inputs)
	if (locale === "es") return es_order_statuses_complete_delivered_removal_point(inputs)
	if (locale === "fr") return fr_order_statuses_complete_delivered_removal_point(inputs)
	if (locale === "hu") return hu_order_statuses_complete_delivered_removal_point(inputs)
	if (locale === "it") return it_order_statuses_complete_delivered_removal_point(inputs)
	if (locale === "nl") return nl_order_statuses_complete_delivered_removal_point(inputs)
	if (locale === "pl") return pl_order_statuses_complete_delivered_removal_point(inputs)
	if (locale === "pt") return pt_order_statuses_complete_delivered_removal_point(inputs)
	return sv_order_statuses_complete_delivered_removal_point(inputs)
};
export { order_statuses_complete_delivered_removal_point as "order_statuses.complete_delivered_removal_point" }